import { render, staticRenderFns } from "./image-edit.vue?vue&type=template&id=054d0c98&scoped=true"
import script from "./image-edit.vue?vue&type=script&lang=ts"
export * from "./image-edit.vue?vue&type=script&lang=ts"
import style0 from "./image-edit.vue?vue&type=style&index=0&id=054d0c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054d0c98",
  null
  
)

export default component.exports